module.exports = __webpack_public_path__ + "static/media/ProjectDescription.452a4389.pdf";